import { MainContainer } from './MainContainer';

import './App.css';

function App() {
    return (
        <div className="App">
            <MainContainer />
        </div>
  );
}

export default App;
